import { render, staticRenderFns } from "./SpeakerModal.vue?vue&type=template&id=0bceb07b&scoped=true"
import script from "./SpeakerModal.vue?vue&type=script&lang=js"
export * from "./SpeakerModal.vue?vue&type=script&lang=js"
import style0 from "./SpeakerModal.vue?vue&type=style&index=0&id=0bceb07b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bceb07b",
  null
  
)

export default component.exports